export default __webpack_public_path__ + "static/media/insta-1.caa37f91.jpg";